import React, { FC } from 'react';
import { InfoView } from 'components/InfoView';
import { translationKeys, useTranslation } from 'services/localization';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import IncomingMessage from './incoming-message.svg';

const styles = css({
  maxHeight: '250px',
  padding: token('space.200'),
});

const EmptyView: FC = () => {
  const { translate } = useTranslation();
  return (
    <InfoView
      title={translate(translationKeys.EMPTY_USER_SUBSCRIPTIONS_MESSAGE)}
      hero={<IncomingMessage css={styles} />}
    />
  );
};

export default EmptyView;
